import { inject, Service } from '@angular/core';
import { tap } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { Api } from '@api/api';
import {
  createOrder,
  getMonobankPayment,
  getPaymentDetailsCard,
  getPaymentDetailsOnline,
} from '@api/functions';
import type { AddOrderDto } from '@api/models';
import { ShippingMethodExtEnum } from '../../enums/shipping-method-ext.enum';

@Service()
export class OrderService {
  private api = inject(Api);

  orderPlaced$ = new Subject<void>();
  shippingMethod$ = new BehaviorSubject<ShippingMethodExtEnum>(null);

  placeOrder(addOrderDto: AddOrderDto) {
    return this.api.invoke(createOrder, { body: addOrderDto })
      .pipe( tap(() => this.orderPlaced$.next()) );
  }

  fetchOnlinePaymentDetails(orderId: number) {
    return this.api.invoke(getPaymentDetailsOnline, { id: orderId });
  }

  fetchMonobankPayment(orderId: number) {
    return this.api.invoke(getMonobankPayment, { id: orderId });
  }

  fetchCardPaymentDetails(orderId: number) {
    return this.api.invoke(getPaymentDetailsCard, { id: orderId });
  }
}
